
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useNavigate } from 'react-router-dom';

interface DashboardLayoutProps {
  children: React.ReactNode;
  isLoading?: boolean;
  onLogout?: () => void;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ 
  children, 
  isLoading = false,
  onLogout
}) => {
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    if (onLogout) {
      await onLogout();
      navigate('/login');
    }
  };
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header 
        isLoggedIn={true}
        onLogout={handleLogout}
      />
      
      <main className="flex-grow py-8 bg-gray-50">
        {isLoading ? (
          <div className="flex items-center justify-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
        ) : (
          children
        )}
      </main>
      
      <Footer />
    </div>
  );
};

export default DashboardLayout;
